import React, { useState } from "react";
import {
  HoverCard,
  HoverCardContent,
  HoverCardPortal,
  HoverCardTrigger,
} from "@/components/elements/HoverCard";
import { History } from "lucide-react";

export const HistoryTableHoverCard = (props: {
  tableName: string;
  parentTableName?: string;
  children: React.ReactElement;
}) => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <HoverCard
      openDelay={100}
      closeDelay={100}
      open={isOpen}
      onOpenChange={setIsOpen}
    >
      <HoverCardTrigger tabIndex={0} asChild>
        {props.children}
      </HoverCardTrigger>
      <HoverCardPortal>
        <HoverCardContent side="top" className="w-80 p-3">
          <div className="space-y-3 text-sm">
            <header className="flex items-center gap-2">
              <History className="size-4 shrink-0 text-muted-foreground" />
              <span className="truncate font-semibold">{props.tableName}</span>
            </header>
            <div>
              This is a <strong>history table</strong> that automatically
              captures all rows synced from{" "}
              {props.parentTableName ? (
                <code>{props.parentTableName}</code>
              ) : (
                "the source table"
              )}
              .
            </div>
            <div>
              On each sync, rows are appended for every record — not only those
              that changed. This allows you to track the full state of your data
              over time. History tables are append-only — existing rows are
              never modified or deleted.
            </div>
            <div className="text-xs text-muted-foreground">
              This table is managed automatically and cannot be configured
              independently.
            </div>
          </div>
        </HoverCardContent>
      </HoverCardPortal>
    </HoverCard>
  );
};
